<script setup lang="ts">
import ListGameName from "@/components/lists/list-game-name.vue";

defineProps<{
  gameId: string;
}>();
</script>

<template>
  <section class="tab-console">
    <div class="content">
      <list-game-name :owner-id="gameId" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.tab-console {
  display: flex;
  flex-direction: column;
  padding-block: 1rem;
  gap: 1rem;

  .content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}

@media screen and (max-width: 1024px) {
  .tab-console {
    .content {
      padding-inline: 0;
    }
  }
}
</style>
